/**
 * @typedef {Object} StoredData
 * @prop {boolean} allowAnalytics
 */

const _LOCAL_STORAGE_KEY = 'reliv.analytics.v3';

export function setAllowAnalytics(/** @type boolean */ allowAnalytics) {
    localStorage.setItem(
        _LOCAL_STORAGE_KEY,
        JSON.stringify({
            ...JSON.parse(localStorage.getItem(_LOCAL_STORAGE_KEY)),
            allowAnalytics,
        })
    );
}

export function getAllowAnalytics() {
    /** @type {StoredData} */
    const storedData = JSON.parse(localStorage.getItem(_LOCAL_STORAGE_KEY))
        || { allowAnalytics : true };
    return storedData.allowAnalytics;
}
